export default {
    TASK_VISIT: 'TASK_VISIT',
    OPERATION_SHIFT: 'OPERATION_SHIFT',
    HOMEBASE: 'HOMEBASE',
    BREAK: 'BREAK',
    LUNCH: 'LUNCH',
    NIGHT: 'NIGHT',
    REFUEL: 'REFUEL',
    SHIFT_START_VISIT: 'SHIFT_START_VISIT',
    SHIFT_END_VISIT: 'SHIFT_END_VISIT',
    TOUR_BACKGROUND: 'TOUR_BACKGROUND',
    TOUR_END: 'TOUR_END',
    PICKUP: 'PICKUP',
    DROP: 'DROP'
};
